import { appAxios } from "@/core/utils/appAxios";
import { watchEffect } from "@vue/runtime-core";
import { ErrorMessage, Field, Form, useField, useForm } from "vee-validate";
import { Options, setup, Vue } from "vue-class-component";
import { i18n } from "@/shared/i18n/i18n";
import * as yup from "yup";
import {
    APIResponse,
    PutAuthPasswordRequestBody,
} from "@/shared/api-contract/api-contract";
import { appModel } from "@/app.model";

const initialFormValues = {
    old_password: "",
    new_password: "",
    new_password_repeated: "",
};

@Options({
    components: {
        Form,
        Field,
        ErrorMessage,
    },
})
export class ChangePassword extends Vue {
    inputType = "password";
    oldPasswordFocused = false;
    newPasswordFocused = false;
    repeatedPasswordFocused = false;

    isLoading = false;

    form = setup(() => {
        const form = useForm<
            PutAuthPasswordRequestBody & { new_password_repeated: string }
        >({
            initialValues: initialFormValues,
        });

        useField("old_password", yup.string().required());
        useField("new_password", yup.string().required());
        useField(
            "new_password_repeated",
            yup
                .string()
                .required()
                .test((value) => value === form.values.new_password),
        );

        watchEffect(() => {
            form.resetForm({
                values: initialFormValues,
            });
        });

        return {
            ...form,
            onSubmit: form.handleSubmit(this.handleSubmit.bind(this)),
        };
    });

    showPassword() {
        this.inputType === "password"
            ? (this.inputType = "text")
            : (this.inputType = "password");
    }

    /* API Connectivity --------------------------------------------------------------------------------------------- */
    async handleSubmit(data: PutAuthPasswordRequestBody) {
        this.isLoading = true;
        await appAxios.value
            .put<APIResponse<undefined>>("/client/web/auth/password", data)
            .then(async (response) => {
                if (response.data.status.code === 200) {
                    appModel.toast.value.add({
                        severity: "success",
                        summary: `${i18n.global.t("signUp.password")} ${i18n.global.t(
                            "common.updated",
                        )}`,
                        life: 3000,
                    });
                    // TODO: display toast message on successful update!
                } else {
                    appModel.toast.value.add({
                        severity: "error",
                        summary: `${i18n.global.t("signUp.password")} ${i18n.global.t(
                            "common.error",
                        )}`,
                        life: 3000,
                    });
                }
            })
            .catch(console.log)
            .finally(() => (this.isLoading = false));
    }
}
